export default {
  name: "shopping-basket",
  contents:
    '<path d="M19.9993 14.6673L18.666 26.6673M25.3327 14.6673L19.9993 5.33398M2.66602 14.6673H29.3327M4.66602 14.6673L6.79935 24.534C6.92402 25.1454 7.25915 25.6937 7.74639 26.0835C8.23364 26.4733 8.84216 26.6799 9.46602 26.6673H22.5327C23.1565 26.6799 23.7651 26.4733 24.2523 26.0835C24.7395 25.6937 25.0747 25.1454 25.1993 24.534L27.466 14.6673M5.99935 20.6673H25.9993M6.66602 14.6673L11.9993 5.33398M11.9993 14.6673L13.3327 26.6673" />',
  attrs: {
    viewBox: "0 0 32 32",
  },
  tags: ["shopping", "basket", "shop", "cart", "canasta", "compras", "compra"],
};
